import styled from "styled-components";

const CardMedia = {
  desktop: "@media(min-width: 768px)",
};

export const CardContainer = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@700&display=swap");
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 250px;
  height: 70px;
  background: #121214;
  border-radius: 4px;
  margin: 10px;
  padding: 5px 15px;
  font-family: "Inter" sans-serif;
  ${CardMedia.desktop} {
    width: 670px;
  }
  button {
    width: 40px;
    height: 30px;
    background: #343b41;
    border-radius: 4.06066px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 14.2123px;
    line-height: 24px;
    color: #f8f9fa;
  }
  p {
    color: #868e96;
    font-style: normal;
    font-weight: 400;
    font-size: 12.182px;
    line-height: 22px;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 120px;
`;
